import { Label } from '@a-ui/react';
import dayjs from 'dayjs';
import React from 'react';
import { translate } from '../../i18n';
import LayoutTile from '../LayoutTile';
import Typography from '../Typography';

interface AppointmentProps {
  data: Api.Appointment;
}

const Appointment: React.FC<AppointmentProps> = ({ data }) => {
  const now = React.useMemo(() => dayjs(), []);
  const date = dayjs(data.startTime);

  return (
    <LayoutTile
      key={data.id}
      label={data.product.name}
      to={data.url}
      toLabel={translate('ecounter.appointments.toLabel')}
      target="_blank"
    >
      <Typography classNames={['u-text-light']}>{data.location.name}</Typography>
      <Typography classNames={['u-text-light']}>
        {date.format('DD MMMM YYYY, H.mm')} {translate('ecounter.appointments.date.hour_notation')}
      </Typography>
      <Label className="u-margin-right-xs u-margin-top-xs">
        {translate('ecounter.appointments.label')}
      </Label>
      {date.isAfter(now) ? (
        <Label type="success">{translate('ecounter.appointments.planned')}</Label>
      ) : (
        <Label className="a-label--light">{translate('ecounter.appointments.passed')}</Label>
      )}
    </LayoutTile>
  );
};

export default Appointment;
